import { useState } from "react";

export default function Gallery() {
  const [activeTab, setActiveTab] = useState("all");
  const [activeImage, setActiveImage] = useState(null);

  const images = [
    // CARDAMOM
    { src: "/assets/cardamom/img11.webp", type: "Cardamom" },
    { src: "/assets/cardamom/img12.webp", type: "Cardamom" },
    { src: "/assets/cardamom/img13.webp", type: "Cardamom" },
    { src: "/assets/cardamom/img14.webp", type: "Cardamom" },
    { src: "/assets/cardamom/img15.webp", type: "Cardamom" },
    { src: "/assets/cardamom/img16.webp", type: "Cardamom" },

    // PEPPER
    { src: "/assets/pepper/pp1.JPG.webp", type: "Pepper" },
    { src: "/assets/pepper/pp2.webp", type: "Pepper" },
    { src: "/assets/pepper/pp3.JPG.webp", type: "Pepper" },
    { src: "/assets/pepper/pp4.webp", type: "Pepper" },
    { src: "/assets/pepper/pp5.webp", type: "Pepper" },
    { src: "/assets/pepper/pp6.webp", type: "Pepper" },
    { src: "/assets/pepper/pp7.webp", type: "Pepper" },
    { src: "/assets/pepper/pp8.webp", type: "Pepper" },

    // PACKAGING
    { src: "/assets/pack/pack1.webp", type: "Packaging" },
    { src: "/assets/pack/pack2.webp", type: "Packaging" },
    { src: "/assets/pack/pack3.webp", type: "Packaging" },
  ];

  const filtered =
    activeTab === "All"
      ? images
      : images.filter((img) => img.type === activeTab);

  return (
    <section className="py-24 bg-[#f6f7f5]">
      <h2 className="text-center text-4xl font-serif mb-12">
        Gallery
      </h2>

      <div className="flex justify-center gap-4 mb-10 flex-wrap">
        {["All", "Cardamom", "Pepper", "Packaging"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-6 py-2 rounded-full border ${activeTab === tab
                ? "bg-[#0a7d4f] text-white"
                : "border-gray-300"
              }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
        {filtered.map((img, i) => (
          <div
            key={i}
            onClick={() => setActiveImage(img.src)}
            className="cursor-pointer overflow-hidden rounded-xl"
          >
            <img
              src={img.src}
              alt="Gallery"
              className="w-full h-60 object-cover hover:scale-105 transition"
            />
          </div>
        ))}
      </div>

      {activeImage && (
        <div
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
          onClick={() => setActiveImage(null)}
        >
          <img
            src={activeImage}
            alt="Preview"
            className="max-h-[90vh] max-w-[90vw]"
          />
        </div>
      )}
    </section>
  );
}
